import numeral from 'numeral';

export const formatNumber = (value: number) => {
  const valueNumeral = numeral(value);
  return valueNumeral.format(`0,0`);
};
